import { render, staticRenderFns } from "./quesList.vue?vue&type=template&id=2fe54b90&"
import script from "./quesList.vue?vue&type=script&lang=js&"
export * from "./quesList.vue?vue&type=script&lang=js&"
import style0 from "./quesList.vue?vue&type=style&index=0&id=2fe54b90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports